import Icon from "@ant-design/icons";

const SVG = () => (
  <svg width="1em" height="1em" viewBox="0 0 24 24" fill="currentColor">
    <title></title>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6 4q.3-.3.713-.3t.712.3L9 5.6q.3.3.3.7T9 7t-.712.3t-.713-.3l-1.6-1.575q-.3-.3-.288-.712T6 4m7-2.9q.425 0 .713.288T14 2.1v2.25q0 .425-.288.713T13 5.35t-.712-.287T12 4.35V2.1q0-.425.288-.712T13 1.1M17 15q.3-.3.713-.3t.712.3L20 16.6q.3.3.3.7t-.3.7t-.713.3t-.712-.3l-1.6-1.575q-.3-.3-.288-.712T17 15m3-11q.3.3.3.713t-.3.712l-1.6 1.6q-.3.3-.7.288T17 7t-.3-.712t.3-.713L18.575 4q.3-.3.713-.3T20 4m2.9 7q0 .425-.288.713T21.9 12h-2.25q-.425 0-.712-.288T18.65 11t.288-.712t.712-.288h2.25q.425 0 .713.288T22.9 11M5.125 21.7L2.3 18.875q-.3-.3-.3-.7t.3-.7l9.075-9.1Q12.25 7.5 13.5 7.5t2.125.875t.875 2.125t-.875 2.125l-9.1 9.075q-.3.3-.7.3t-.7-.3m6.975-8.375l-.362-.35l-.363-.35l-.35-.35l-.35-.35l.7.7zM5.825 19.6l6.275-6.275l-1.425-1.4l-6.25 6.25z"
    />
  </svg>
);

const WandIcon = (props) => <Icon component={SVG} {...props} />;

export default WandIcon;
